import { Spin } from 'antd';
import React, { useState } from 'react';
import { StockLevelReport } from '../../../types';
import BaseTable from '../../../components/BaseTable';
import { roundAndFormat } from '../../../lib/utils';

const StockTable = ({
  data,
  isLoading,
}: {
  data: StockLevelReport[] | undefined;
  isLoading: boolean;
}) => {
  const [spinning] = useState<boolean>(false);

  const columns = [
    {
      title: 'Location',
      dataIndex: 'locationDescription',
    },
    {
      title: 'Product',
      dataIndex: 'productDescription',
    },
    {
      title: 'Product Code',
      dataIndex: 'productCode',
    },
    {
      title: 'Category',
      dataIndex: 'categoryDescription',
    },
    {
      title: 'UoM',
      dataIndex: 'uomDescription',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      render: (_text: any, record: StockLevelReport) =>
        roundAndFormat(record.quantity),
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrice',
      render: (_text: any, record: StockLevelReport) =>
        roundAndFormat(record.unitPrice),
    },
    {
      title: 'Total Price',
      dataIndex: 'totalPrice',
      render: (_text: any, record: StockLevelReport) =>
        roundAndFormat(record.totalPrice),
    },
  ];

  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <BaseTable
        dataSource={data || []}
        isLoading={isLoading}
        columns={columns}
        module={'Stock Report'}
      />
    </>
  );
};

export default StockTable;
